module.exports = require("tinycolor2");